"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactEmotion = require("react-emotion");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var item = /*#__PURE__*/
(0, _reactEmotion.css)("position:relative;&:hover .item-overlay.top{top:0;}.item-overlay{position:absolute;top:0;right:0;bottom:0;left:0;background:#fff;overflow:hidden;/* fix text transition issue for .left and .right but need to overwrite left and right properties in .right */\n\t\twidth:100%;-moz-transition:top 0.3s,right 0.3s,bottom 0.3s,left 0.3s;-webkit-transition:top 0.3s,right 0.3s,bottom 0.3s,left 0.3s;transition:top 0.3s,right 0.3s,bottom 0.3s,left 0.3s;}.item-overlay.top{top:100%;}.item-overlay.left{top:100%;}");
var Overlay = function Overlay(_ref) {
  var content = _ref.content,
    children = _ref.children;
  return _react.default.createElement("div", {
    className: item
  }, children, _react.default.createElement("div", {
    className: "item-overlay top"
  }, content));
};
Overlay.propTypes = {
  content: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
};
var _default = Overlay;
exports.default = _default;